// extracted by mini-css-extract-plugin
export default {"zoomModal":"i1-z","image":"j1-z","button":"k1-z","isOverlayShown":"l1-z"};